import ShieldIcon from '@mui/icons-material/Shield';

interface TeamTierBadgeProps {
    /** Team name, for the tooltip. */
    teamName?: string | null;
    /** Rendered as a small overlay on a logo rather than an inline pill. */
    corner?: boolean;
}

/**
 * Marks a team that holds the team donator tier. Unlike the personal badges in this folder this one
 * belongs to the team, not the player — covered players get no badge of their own.
 */
export const TeamTierBadge: React.FC<TeamTierBadgeProps> = ({ teamName, corner }) => {
    // Spelled out rather than just the team name: this badge appears next to logos all over the
    // site, where "X støtter PowerStats" alone does not say what the mark on the logo means.
    const title = teamName
        ? `Hold-donator — ${teamName} støtter PowerStats`
        : 'Hold-donator — holdet støtter PowerStats';

    if (corner) {
        return (
            <span
                title={title}
                aria-label={title}
                style={{
                    position: 'absolute',
                    right: -3,
                    bottom: -3,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '45%',
                    height: '45%',
                    minWidth: 12,
                    minHeight: 12,
                    maxWidth: 20,
                    maxHeight: 20,
                    borderRadius: '50%',
                    background: '#f15c25',
                    border: '1.5px solid #14161a',
                    boxShadow: '0 0 6px rgba(241,92,37,0.5)',
                    // No pointerEvents:none here — the badge must be its own hover target, or the
                    // parent's title (the team name) wins and the badge never explains itself.
                    cursor: 'help',
                }}
            >
                <ShieldIcon style={{ width: '70%', height: '70%', color: '#fff' }} />
            </span>
        );
    }

    return (
        <span
            className="badge rounded-pill m-1"
            title={title}
            style={{ background: 'rgba(241,92,37,0.18)', color: '#ff9933', border: '1px solid #f15c25' }}
        >
            <ShieldIcon fontSize="small" />
        </span>
    );
};
